import Link from "next/link";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { articlePath, type BlogCardData } from "@/lib/blog";

function NavCard({
  article,
  direction,
}: {
  article: BlogCardData;
  direction: "prev" | "next";
}) {
  const isPrev = direction === "prev";
  return (
    <Link
      href={articlePath(article)}
      className={`card-flat group flex flex-col gap-1.5 bg-white/60 p-5 transition-all duration-300 ${
        isPrev ? "items-start text-left" : "items-end text-right"
      }`}
    >
      <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-ink-faint">
        {isPrev && <ArrowLeft size={13} className="group-hover:-translate-x-0.5 transition-transform" aria-hidden="true" />}
        {isPrev ? "Vorheriger Artikel" : "Nächster Artikel"}
        {!isPrev && <ArrowRight size={13} className="group-hover:translate-x-0.5 transition-transform" aria-hidden="true" />}
      </span>
      <span className="font-display font-semibold text-sm leading-snug text-ink group-hover:text-accent transition-colors line-clamp-2">
        {article.title}
      </span>
    </Link>
  );
}

/** Navigation zum vorherigen/nächsten Artikel. */
export default function PrevNextNav({
  prev,
  next,
}: {
  prev?: BlogCardData;
  next?: BlogCardData;
}) {
  if (!prev && !next) return null;
  return (
    <nav aria-label="Weitere Artikel" className="grid sm:grid-cols-2 gap-4">
      {prev ? <NavCard article={prev} direction="prev" /> : <span />}
      {next ? <NavCard article={next} direction="next" /> : <span />}
    </nav>
  );
}
